'use strict';

import React from 'react'

import { centsFromPrice, priceFromCents } from '@root/utility'

import Link  from '@Pure/Link'
import Image from '@Pure/Image'
import Logo from '@Pure/Logo'

class ProductInfos extends React.Component
{
	render ()
	{
		const component = this, props = this.props, state = component.state;

		const ticket = props.ticket;

		let price  = centsFromPrice(ticket.product.price.price);
		let status = (ticket.product.tickets || { })[ticket.ticket_id];

		let date = window.moment(ticket.order.createdAt).format('ddd D MMMM');

		let status_label = 'Acheté';
		let status_class = ' c-status-indicator--';

		let ticket_infos = ticket.product.tickets[ticket.ticket_id] || { };

		if (ticket_infos.status === 'new')
		{
			status_class += 'grey';
		}
		else if (ticket_infos.status === 'processing')
		{
			status_class += 'blue';
			status_label = 'Réservé'
		}
		else if (ticket_infos.status === 'completed')
		{
			status_class += 'green';
			status_label = 'Terminé';
		}
		else if (ticket_infos.status === 'canceled')
		{
			status_class += 'red';
			status_label = 'Annulé';
		}

		let product_status =
		(
			<div className={ 'c-status-indicator' + status_class }>
				<div className="c-status-indicator__circle"></div>
				{ status_label }
			</div>
		);

		let tracking_actions, num_actions;

		if (props.actions)
		{
			tracking_actions = props.actions['tracking'];
			num_actions      = props.actions['num'];
		}

		let tracking =
		(
			<div className="c-order-ticket__tracking">
				{ ticket_infos.tracking }
				{ tracking_actions }
			</div>
		);

		if (ticket.order.shipping.method !== 'home')
		{
			tracking = <div className="c-order-ticket__tracking disabled"></div>
		}

		let infos;

		if (ticket_infos.name && ticket_infos.name.name)
		{
			infos =
			(
				<div>
					{ ticket_infos.name.name + ' ' }
					({ ticket_infos.name.date })
					{ ' - ' }
					<strong>{ ticket.order.user.login }</strong>
				</div>
			);
		}

		let ticket_row =
		(
			<div className="c-order-ticket">

				<div className="c-order-ticket__ref">{ ticket.product.price.ref }</div>

				<div className="c-order-ticket__date">{ date }</div>

				<div className="c-order-ticket__name">{ infos }</div>

				<div className="c-order-ticket__num">
					{ ticket_infos.num }
					{ num_actions }
				</div>

				{ tracking }

				<div className="c-order-ticket__status">{ product_status }</div>

			</div>
		);

		let output =
		(
			<div className="c-order-infos">

				{ ticket_row }

			</div>
		);

		return output;
	}
}

export default ProductInfos